<template>
  <div class="container">
    <!-- 标题 -->
    <div class="chat-title">{{isKeyWord ? '聊天内容' : '与'+sendToRemark+'('+sendTo+')'+'的聊天' }}</div>
    <div class="chat-content" ref="ctx">
      <div class="chat-list">
        <!-- recordContent 聊天记录数组-->
        <div v-for="(itemc, indexc) in recordContent" :key="indexc" >
          <!-- 对方 -->
          <div class="word" v-if="!itemc.mineMsg" >
            <div class="time">
              <div class="nick-name">{{ itemc.nickName }}</div>
              <span>{{ itemc.timestamp }}</span>       
            </div> 
            <div class="main">
              <img class="userImage" :src="itemc.headUrl" />
              <div class="info">
                <div style="display: flex;justify-content: center;align-items: center;height:100%;">
                  <div v-if="itemc.msgType == 'text'" class="info-content" v-html="itemc.contactText">
                  </div>
                  <audio-record v-else-if="itemc.msgType == 'voice'" :src="itemc.audioUrl" type="left"></audio-record>
                  <file-record v-else-if="itemc.msgType == 'file'" :url="itemc.fileUrl" :size="itemc.fileSize || '未知'" :fileType="itemc.fileExt" type="left"></file-record>
                  <img-record v-else-if="itemc.msgType == 'image' || itemc.msgType == 'emotion'" :src="itemc.imgUrl" type="left"></img-record>
                  <div v-else-if="itemc.msgType == 'image'||itemc.msgType =='emotion'" class="image">
                    <viewer>
                      <img
                        :src="itemc.imgUrl"
                        style="width: auto;height: auto;max-width: 30%;border-radius: 0%;margin-top:5px;"
                      />
                    </viewer>
                  </div>
                  <!-- 撤回的消息 -->
                  <div v-else-if="itemc.msgType == 'revoke'" >
                    <div v-if="itemc.imgUrl" class="image">
                      <viewer>
                        <div style="display: inline;position: relative;">
                          <img :src="itemc.imgUrl"
                            style="width: auto;height: auto;max-width: 30%;border-radius: 0%;margin-top:5px;"
                          />
                          <div class="revoke-tip" style="position: absolute;right: 0;">已撤回</div>
                        </div>
                      </viewer>
                    </div>
                    <div style="position: relative;" v-else>
                      <div class="info-content" v-html="itemc.contactText"></div>
                      <div class="revoke-tip">已撤回</div>
                    </div>
                  </div>
                  <!-- <div class="audio-content" v-else-if="itemc.msgType == 'voice'">
                    <m-audio :src="itemc.audioUrl"></m-audio>
                  </div> -->
                  <text-record v-else :content="itemc.contactText" type="left"></text-record>

                  <!-- <div v-else class="info-content">{{ itemc.contactText }}</div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 我的 -->
          <div class="word-my" v-else >
            <div class="time">
              <div class="nick-name">{{ itemc.nickName }}</div>
              <span>{{ itemc.timestamp }}</span>       
            </div>
            <div class="main">
              <div class="info">
                <div style="display: flex;justify-content: flex-end;align-items: center;height:100%;">
                  <!-- 文本 -->
                  <div v-if="itemc.msgType == 'text'" class="info-content" v-html="itemc.contactText"></div>
                  <audio-record v-else-if="itemc.msgType == 'voice'" :src="itemc.audioUrl" type="right"></audio-record>
                  <file-record v-else-if="itemc.msgType == 'file'" :url="itemc.fileUrl" :size="itemc.fileSize || '未知'" :fileType="itemc.fileExt" type="right"></file-record>
                  <!-- 图片 -->
                  <img-record v-else-if="itemc.msgType == 'image' || itemc.msgType == 'emotion'" :src="itemc.imgUrl" type="right"></img-record>

                  <!-- <div v-else-if="itemc.msgType == 'image'||itemc.msgType =='emotion'" class="image">
                    <viewer>
                      <img
                        :src="itemc.imgUrl"
                        style="width: auto;height: auto;max-width: 30%;border-radius: 0%;margin-top:5px;"
                      />
                    </viewer>
                  </div> -->
                  <!-- 撤回的消息 -->
                  <div v-else-if="itemc.msgType == 'revoke'" >
                    <div v-if="itemc.imgUrl" class="image">
                      <viewer>
                        <div style="display: inline;position: relative;">
                          <img
                            :src="itemc.imgUrl"
                            style="width: auto;height: auto;max-width: 30%;border-radius: 0%;margin-top:5px;"
                          />
                          <div class="revoke-tip">已撤回</div>
                        </div>
                      </viewer>
                    </div>
                    <div style="position: relative;" v-else>
                      <div class="info-content" v-html="itemc.contactText"></div>
                      <div class="revoke-tip">已撤回</div>
                    </div>
                  </div>
                  <!-- <div class="audio-content" v-else-if="itemc.msgType == 'voice'">
                    <m-audio :src="itemc.audioUrl"></m-audio>
                  </div> -->
                  <text-record v-else :content="itemc.contactText" type="right"></text-record>
                </div>
              </div>
              <span class="userImage">{{getAvatarName(itemc.nickName)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getChatContent} from "@/api/senWord/senWord.js"
import audioRecord from '@/components/chatLog/lib/audio-record.vue'
import fileRecord from '@/components/chatLog/lib/file-record.vue'
import imgRecord from '@/components/chatLog/lib/img-record.vue'
import TextRecord from '@/components/chatLog/lib/text-record.vue'
export default {
  name: 'SenWordChatCommon',
  components: {audioRecord, fileRecord, imgRecord, TextRecord },
  data() {
    return {
      recordContent: [],
      sendTo: '',     // 客户昵称
      sendToRemark: '',    // 员工给客户起的备注
      msgId: '',
      firstCurrentId: 0,
      isKeyWord: false
    };
  },
  created() {
  
    // this.recordContent =  [
    //         {
    //             "headUrl": "http://wx.qlogo.cn/mmhead/O5IB5rptd1pbzcM1iaYjYty9HZgt0uzHrCJnCd8EBVK3DRcoEeqA6uA/0", //头像地址
    //             "nickName": "。。", //昵称
    //             "timestamp": "2023-04-12 17:49:21", //时间
    //             "contactText": "[微笑]", //内容
    //             "msgType": "text", //消息类型  文本(text)、图片(image)、语音(voice)、文件（file）
    //             "imgUrl": null, //图片地址
    //             "audioUrl": null, //语言地址
    //             "msgId": "10213740190725128159_1681292965952_external", //消息id
    //             "fileUrl": null, //文件地址
    //             "fileSize": null, //文件大小
    //             "fileExt": null, //文件后缀
    //             "nickNameType": 2, //消息发送者类型 1-员工 2-客户
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": "https://wework.qpic.cn/bizmail/srKFoFpeBLAEPRX8Ky9VXBFWvyWxT1sy3d8mYJXib1NoQV3sFzw5LzA/0",
    //             "nickName": "麦剑鸿",
    //             "timestamp": null,
    //             "contactText": "试试",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "16713922045916105039_1681292946668_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 2,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": "http://wx.qlogo.cn/mmhead/O5IB5rptd1pbzcM1iaYjYty9HZgt0uzHrCJnCd8EBVK3DRcoEeqA6uA/0",
    //             "nickName": "。。",
    //             "timestamp": null,
    //             "contactText": "hello",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "18366292588201144845_1681284704450_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 2,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": "http://wx.qlogo.cn/mmhead/IJdPq631CVFbThKBoUYfKDAYrJhtrphVTL5xE3F1sjmia0zkpGdgqvg/0",
    //             "nickName": "一把剑",
    //             "timestamp": null,
    //             "contactText": "111",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "3403130063631422266_1681283966970_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 2,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": null,
    //             "nickName": "麦剑鸿",
    //             "timestamp": null,
    //             "contactText": "",
    //             "msgType": "file",
    //             "imgUrl": "http://wecom.test.hmcsoft.net:8008/fileUploadPath/202304/wwd084d7152c3a1e1b/file/新建 XLSX 工作表.xlsx",
    //             "audioUrl": null,
    //             "msgId": "13841121668374430903_1681282415600_external",
    //             "fileUrl": "http://wecom.test.hmcsoft.net:8008/fileUploadPath/202304/wwd084d7152c3a1e1b/file/新建 XLSX 工作表.xlsx",
    //             "fileSize": 10132,
    //             "fileExt": "xlsx",
    //             "nickNameType": 1,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": null,
    //             "nickName": "麦剑鸿",
    //             "timestamp": null,
    //             "contactText": "说没事没事没事没事没事没事没事吗",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "2169568744739129452_1681282404295_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 1,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": null,
    //             "nickName": "周紫光",
    //             "timestamp": null,
    //             "contactText": "对的",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "17237176369229400798_1680525672399_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 1,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": null,
    //             "nickName": "周紫光",
    //             "timestamp": null,
    //             "contactText": "对吗",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "16283769807056488288_1680525668183_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 1,
    //             "mineMsg":false   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": null,
    //             "nickName": "周紫光",
    //             "timestamp": null,
    //             "contactText": "xd",
    //             "msgType": "text",
    //             "imgUrl": null,
    //             "audioUrl": null,
    //             "msgId": "2203247332477072450_1680525663258_external",
    //             "fileUrl": null,
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 1,
    //             "mineMsg":true   // true 员工 false: 客户
    //         },
    //         {
    //             "headUrl": "http://wx.qlogo.cn/mmhead/IJdPq631CVFbThKBoUYfKDAYrJhtrphVTL5xE3F1sjmia0zkpGdgqvg/0",
    //             "nickName": "一把剑",
    //             "timestamp": null,
    //             "contactText": "",
    //             "msgType": "image",
    //             "imgUrl": "http://wecom.test.hmcsoft.net:8008/fileUploadPath/202304/wwd084d7152c3a1e1b/image/490b7daa7e24421b892c2782759f6c69.jpg",
    //             "audioUrl": null,
    //             "msgId": "16162907972322813291_1680518643899_external",
    //             "fileUrl": "http://wecom.test.hmcsoft.net:8008/fileUploadPath/202304/wwd084d7152c3a1e1b/image/490b7daa7e24421b892c2782759f6c69.jpg",
    //             "fileSize": null,
    //             "fileExt": null,
    //             "nickNameType": 2,
    //             "mineMsg":true   // true 员工 false: 客户
    //         }
    //     ]
  },
  mounted(){
    // console.log('aaa')
    // console.log(this.$refs.ctx)
   
  },
  methods: {
    // 发送请求获取消息记录
    getData(params,key, type= 1, keys = false) {
      console.log("params",params)
      console.log("key",key)
      let that = this;
      that.recordContent = [];
      that.msgId = params.msgId;
      this.firstCurrentId = 0;
      that.isKeyWord = keys
      getChatContent(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          let temList = JSON.parse(JSON.stringify(res.data.dialog));
          // console.log("that.msgId", that.msgId)
          temList.forEach((item, index) => {
            // item.contactText && item.msgId == that.msgId
            // console.log(index, item.contactText && item.contactText.search(key) != -1)
            if(item.contactText && item.contactText.search(key) != -1) {
              if(type == 1){
                item.contactText = that.keywordscolorful(key,item.contactText)
              }else{
                item.contactText = that.keywordscolorful1(key,item.contactText)
              }
              if(this.firstCurrentId == 0){
                this.firstCurrentId = index
              }
            }
          });
          that.recordContent =  temList;
          that.sendTo = res.data.sendTo;
          that.sendToRemark = res.data.sendToRemark;
          // 定位到第一个敏感词出现的地方
          let height = 0
          setTimeout(()=>{
            let wordNum = document.querySelector('.chat-list').children
            for(let i=0; i < this.firstCurrentId; i++){
              height += wordNum[i].getBoundingClientRect().height
            }
            this.$refs.ctx.scrollTop = height
          }, 500)
        }
      //结束
      }).catch(err => {
        console.log(err,'errr')
      })
    },
    getAvatarName(str) {
      let reg = /[\u4e00-\u9fa5]/g
       str = str.match(reg)==null?'':str.match(reg).join('')
      let avatorName = ''
      if(str.length >2) {
        avatorName = str.substring(str.length - 2)
      }else if(str.length != 0) {
        avatorName = str
      }else {
        avatorName = '默认'
      }
      return avatorName
    },
    keywordscolorful(key,content) {
      let reg = new RegExp("(" + key + ")", "g");
      let newstr = content.replace(reg, "<span style='background-color:#ff7f43; color: #fff'>$1</span>");
      return newstr;
    },
    keywordscolorful1(key,content) {
      let reg = new RegExp("(" + key + ")", "g");
      let newstr = content.replace(reg, "<span style='background-color:#33bfff; color: #fff'>$1</span>");
      return newstr;
    }
  },
  updated: function () {
  },
};
</script>
<style lang="scss">
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .chat-title {
      color: black;
      text-align: left;
      padding: 10px 0 10px 20px;
      border-bottom: 2px solid #F4F4F4;
    }
    .chat-content {
      flex: 1;
      overflow-y: scroll;
      background-color: #f5f5f5;
      .chat-list {
        padding-bottom: 10px;
        background-color: rgb(245,245,245);
        .ohou {
          text-align: center;
        }
        .word {
          display: flex;
          flex-direction: column;
          padding: 15px 10px;
          .time {
            font-size: 12px;
            color: #9098aa;
            margin: 0;
            display: flex;
            line-height: 20px;
            margin-top: -5px;
            text-align: left;
            margin-left: 52px;
            .nick-name {
              /* 文本不换行 */
              white-space: nowrap;
              /* 超出范围隐藏 */
              overflow: hidden;
              /* 文字超出用省略号 */
              text-overflow: ellipsis;
              max-width: 11em;
              margin-right: 2px;
            }
          }
          .main {
            display: flex;
            img {
              margin-left: 10px;
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
            .info {
              margin-left: 10px;
              .info-content {
                font-size: 14px;
                padding: 7px 10px;
                border-radius: 6px;
                background: #DEE0E3;
                position: relative;
                margin-top: 5px;
              }
              //小三角形
              .info-content::before {
                position: absolute;
                left: -8px;
                top: 50%;
                transform: translate(0,-50%);
                content: "";
                border-right: 10px solid #DEE0E3;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
              }
              .revoke-tip {
                text-align: right;
                margin-right: 5px;
                font-size: 12px;
                color: #9098AA;
              }
              .audio-content {
                padding: 7px 10px;
                border-radius: 6px;
                background: #DEE0E3;
                position: relative;
                margin-top: 5px;
              }
              @-webkit-keyframes play-dot {
                0% {
                  background:#5cadff;
                }
                to {
                  background:#999;
                }
              }
              @keyframes play-dot {
                0% {
                  background:#5cadff;
                }
                to {
                  background:#999;
                }
              }
              @-webkit-keyframes play-sector {
                0% {
                  border-color:#5cadff;
                }
                to{
                  border-color:#999;
                  }
              }
              @keyframes play-sector {
                0% {
                  border-color:#5cadff;
                }
                to {
                  border-color:#999;
                }
              }
              .x-sector.play{
                -webkit-animation:play-sector .3s ease-in-out .1s;
                animation:play-sector .3s ease-in-out .1s;
              }
              .x-sector.play:before {
                -webkit-animation:play-sector .3s ease-in-out .2s;
                animation:play-sector .3s ease-in-out .2s;
              }
              .x-sector.play:after {
                -webkit-animation:play-sector .3s ease-in-out .3s;
                animation:play-sector .3s ease-in-out .3s;
              }
              .x-sector.play .x-dot {
                -webkit-animation:play-dot .3s ease-in-out;
                animation:play-dot .3s ease-in-out;
              }
              .x-audio-wrap {
                height: 20px;
                box-shadow: none;
                .x-sector {
                  border-right: 2px solid #5cadff;
                  border-top: 2px solid #5cadff;
                  .x-dot {
                    background: #5cadff;
                  }
                }
                .x-sector::before {
                  border-right: 2px solid #5cadff;
                  border-top: 2px solid #5cadff;
                }
                .x-sector::after {
                  border-right: 2px solid #5cadff;
                  border-top: 2px solid #5cadff;
                }
              }
            }
            .userImage {
              margin: auto 0;
            }
          }
        }
        
        .word-my {
          display: flex;
          justify-content: flex-end;
          flex-direction: column;
          padding: 15px 10px;
          img {
            margin-right: 10px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          .time {
            text-align: right;
            font-size: 12px;
            color: #9098AA;
            margin: 0;
            display: flex;
            justify-content: flex-end;
            line-height: 20px;
            margin-top: -5px;
            margin-right: 60px;
            .nick-name {
              /* 文本不换行 */
              white-space: nowrap;
              /* 超出范围隐藏 */
              overflow: hidden;
              /* 文字超出用省略号 */
              text-overflow: ellipsis;
              max-width: 11em;
              margin-right: 2px;
            }
          }
          .main {
            display: flex;
            justify-content: flex-end;
            .info {
              margin-left: 10px;
              text-align: right;
              flex: 1;
              .info-content {
                padding: 7px 10px;
                border-radius: 6px;
                font-size: 14px;
                top: 0;
                right: 0;
                margin-right: 10px;
                position: relative;
                margin-top: 5px;
                background: #4996F6;
                color: #D7E8FD;
                text-align: left;
              }
              //小三角形
              .info-content::after {
                position: absolute;
                right: -8px;
                top: 50%;
                transform: translate(0,-50%);
                content: "";
                // border-left: 10px solid #A3C3F6;
                border-left: 10px solid #4996F6;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
              }
              .revoke-tip {
                margin-left: 5px;
                font-size: 12px;
                color: #9098AA;
                position: absolute;
                left: 0;
              }
              .x-audio-wrap {
                transform: rotateY(180deg);
              }
              .x-time {
                transform: rotateY(-180deg);
                color: white;
              }
              .audio-content {
                padding: 7px 10px;
                border-radius: 6px;
                background: #4996F6;
                position: relative;
                margin-top: 5px;
              }
              @-webkit-keyframes play-dot {
                0% {
                  background:white;
                }
                to {
                  background:#1D61B5;
                }
              }
              @keyframes play-dot {
                0% {
                  background:white;
                }
                to {
                  background:#1D61B5;
                }
              }
              @-webkit-keyframes play-sector {
                0% {
                  border-color:white;
                }
                to{
                  border-color:#1D61B5;
                  }
              }
              @keyframes play-sector {
                0% {
                  border-color:white;
                }
                to {
                  border-color:#1D61B5;
                }
              }
              .x-sector.play{
                -webkit-animation:play-sector .3s ease-in-out .1s;
                animation:play-sector .3s ease-in-out .1s;
              }
              .x-sector.play:before {
                -webkit-animation:play-sector .3s ease-in-out .2s;
                animation:play-sector .3s ease-in-out .2s;
              }
              .x-sector.play:after {
                -webkit-animation:play-sector .3s ease-in-out .3s;
                animation:play-sector .3s ease-in-out .3s;
              }
              .x-sector.play .x-dot {
                -webkit-animation:play-dot .3s ease-in-out;
                animation:play-dot .3s ease-in-out;
              }
              .x-audio-wrap {
                height: 20px;
                box-shadow: none;
                .x-sector {
                  border-right: 2px solid white;
                  border-top: 2px solid white;
                  .x-dot {
                    background: white;
                  }
                }
                .x-sector::before {
                  border-right: 2px solid white;
                  border-top: 2px solid white;
                }
                .x-sector::after {
                  border-right: 2px solid white;
                  border-top: 2px solid white;
                }
              }
            }
            .userImage {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: rgba(72, 145, 255, 0.2);
              color: #4891FF;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: auto 0;
            }
          }
        }
      }
    }
  }
</style>